import { render } from "./GetDeliveryQRandShippingPDF.vue?vue&type=template&id=d36b6bc8&scoped=true"
import script from "./GetDeliveryQRandShippingPDF.vue?vue&type=script&lang=js"
export * from "./GetDeliveryQRandShippingPDF.vue?vue&type=script&lang=js"

import "./GetDeliveryQRandShippingPDF.vue?vue&type=style&index=0&id=d36b6bc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d36b6bc8"]])

export default __exports__